import {createActions} from 'client/framework';

const normalActions = ['SET_SESSION_STATE', 'END_SESSION'];

export default createActions(null, normalActions);
